module.exports = __webpack_public_path__ + "img/hp-logo-256.8a73db82.png";